import { Outlet, useLocation } from 'react-router-dom';

import { useSession } from 'src/api/queries';
import { NavRail } from 'src/components/shell/NavRail';

/**
 * The furniture every screen sits in, except the one that is meant to escape it.
 *
 * The reader (`/nota/…`) renders outside the shell on purpose — Composition §12b: an editor judging
 * whether a piece *works* is doing a different job from an editor checking whether it is *backed*,
 * and the two must not look alike. That escape is the only exception, and it is declared here
 * rather than left to each route to remember.
 */
const UNSHELLED = /^\/nota\//;

export function AdminShell() {
  const location = useLocation();
  // Read once and cached: the rail asks what this account may administer, and the answer decides
  // whether a section that would answer 403 is drawn at all.
  const session = useSession();

  if (UNSHELLED.test(location.pathname)) return <Outlet />;

  return (
    <div className="shell">
      <NavRail canAdminister={session.data?.user.role === 'admin'} />
      <main className="shell__content">
        <Outlet />
      </main>
    </div>
  );
}
